export default __webpack_public_path__ + "static/media/crash-game.b58afd43.mp4";